module.exports = __webpack_public_path__ + "static/images/skin.b0fde83.jpg";